<template>
    <div id="ticket-component">
        <AppBreadCrumb :paths="[{ title: $t('message.ticket') }]" :select="true">
            <div class="chatListSettingContainer">
                <a-button @click="showModal" class="actionButtonBreadcrumb" style="margin-right: 8px">
                    <md-icon>add</md-icon>
                    {{ $t("message.addNewStatus") }}
                </a-button>
                <a-button @click="statusShowModal" class="actionButtonBreadcrumb" style="margin-right: 8px">
                    {{ $t("message.listStatuses") }}
                </a-button>
            </div>
        </AppBreadCrumb>
        <div class="route-page-content breadcrumb-content">
            <SidebarChild :items="menuItems" :focusActive="true" @selected="handleSidebarSelection" />
            <div class="position-relative pt-3" style="padding: 0 30px">
                <a-row>
                    <a-col span="24">
                        <div v-if="selectedTab === 'tickets'">
                            <TicketList :default-filter-template="currentFilterTemplate" />
                        </div>
                        <div v-if="selectedTab === 'instagram'">
                            <TicketList :default-filter-template="'instagram'" />
                        </div>
                        <div v-if="selectedTab === 'facebook'">
                            <TicketList :default-filter-template="'messenger'" />
                        </div>
                        <div v-if="selectedTab === 'trendyol'">
                            <TicketList :default-filter-template="'trendyol'" />
                        </div>
                        <div v-if="selectedTab === 'form'">
                            <TicketList :default-filter-template="'form'" />
                        </div>
                        <div v-if="selectedTab === 'automation'">
                            <TicketList :default-filter-template="'automation'" />
                        </div>
                        <div v-if="selectedTab === 'messenger'">
                            <AwaitingTickets
                                :show-my-tickets="showMyTicket"
                                :tag="selectedTopic"
                                :statuses="statuses"
                                platform="messenger"
                            />
                        </div>

                        <div
                            v-if="
                                selectedTab === 'ticket-forwarding' &&
                                checkPermission(PERMISSION_TYPES['offlineSupportRequest.get'].tr.name)
                            "
                        >
                            <TicketForwarding />
                        </div>
                    </a-col>
                </a-row>
            </div>
        </div>

        <Modal2
            v-if="isModalShow"
            id="ticket-status-form"
            class="ticket-status-form"
            :show-footer="false"
            @cancel="hideModal"
            :title="ticketFormMode ? $t('message.ticketStatusForm') : $t('message.listStatuses')"
        >
            <div v-if="ticketFormMode">
                <b-form class="d-flex flex-column justify-content-center" @submit.prevent="handleSave">
                    <b-row>
                        <b-col md="12">
                            <b-row>
                                <b-col md="12">
                                    <b-form-group :label="$t('message.statusFormTitle')">
                                        <b-form-input
                                            v-model="statusForm.title"
                                            :name="$t('message.statusFormTitle')"
                                            autocomplete="off"
                                            trim
                                            type="text"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col md="12" id="buttons">
                                    <b-button @click="hideModal">
                                        {{ $t("message.cancel") }}
                                    </b-button>
                                    <b-button type="submit" variant="primary" @submit.prevent="handleSave">
                                        <span v-if="!statusForm._id">
                                            {{ $t("message.save") }}
                                        </span>
                                        <span v-else>
                                            {{ $t("message.update") }}
                                        </span>
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-form>
            </div>
            <div v-else>
                <StatusTable :statuses="statuses" @edit="editStatus" @deleted="deleted" />
            </div>
        </Modal2>
    </div>
</template>

<script>
import OSRWaitingAnswer from "../../../components/svg/OSRWaitingAnswer.vue";
import ArchiveIcon from "../../../components/svg/ArchiveIcon.vue";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb.vue";
import AwaitingTickets from "./components/AwaitingTickets.vue";
import TicketHistory from "./components/TicketHistory.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import StatusTable from "../../../components/StatusTable.vue";
import TicketForwarding from "./components/TicketForwarding.vue";
import { createTicketStatus, readTicketStatus, updateTicketStatus } from "../../../api/ticket";
import _ from "lodash";
import Modal2 from "../../../components/common/Modal2.vue";
import { PERMISSION_TYPES } from "../../../language/permissionTypes";
import InstagramIcon from "../../../components/svg/InstagramIcon.vue";
import MessengerIcon from "../Chatbot/pages/integrations/svg/MessengerIcon.vue";
import SidebarChild from "../../../components/Sidebar/SidebarChild.vue";
import TicketList from "./components/TicketList.vue";

export default {
    name: "Ticket",
    data() {
        const platform = this.$route.query.platform;
        return {
            type: "pending-messages",
            timeSelect: "today",
            selectedTab: platform || "tickets",
            selectedTopic: "all",
            showMyTicket: false,
            statusForm: {
                title: "",
            },
            statuses: [],
            ticketFormMode: true,
            isModalShow: false,
            menuItems: [
                {
                    enabled: true,
                    key: "tickets",
                    label: "Tickets",
                    icon: {
                        type: "material-icons",
                        name: "checklist",
                    },
                },
                // {
                //     enabled: true,
                //     key: "pending-messages",
                //     label: this.$t(`message.waitingReply`) || "Pending Messages",
                //     icon: {
                //         type: "component",
                //         name: "Ticket",
                //     },
                // },
                {
                    enabled: true,
                    key: "instagram",
                    label: "Instagram Tickets",
                    icon: {
                        type: "component",
                        name: "InstagramIcon",
                    },
                },
                {
                    enabled: true,
                    key: "facebook",
                    label: "Facebook Tickets",
                    icon: {
                        type: "component",
                        name: "MessengerIcon",
                    },
                },
                {
                    enabled: true,
                    key: "trendyol",
                    label: "Trendyol Tickets",
                    icon: {
                        type: "component",
                        name: "TrendyolIcon",
                    },
                },
                {
                    enabled: true,
                    key: "automation",
                    label: "Automation Tickets",
                    icon: {
                        type: "material-icons",
                        name: "auto_awesome",
                    },
                },
                // {
                //     enabled: true,
                //     key: "archive",
                //     label: this.$t(`chatbotv2.archive`) || "Archive",
                //     icon: {
                //         type: "component",
                //         name: "ArchiveIcon",
                //     },
                // },
                {
                    enabled: true,
                    key: "form",
                    label: "Supsis Form Tickets",
                    icon: {
                        type: "material-icons",
                        name: "text_snippet",
                    },
                },
                {
                    enabled: true,
                    key: "ticket-forwarding",
                    label: this.$t(`ticket.ticketForwarding`) || "Ticket Forwarding",
                    icon: {
                        type: "material-icons",
                        name: "double_arrow",
                    },
                },
            ],
        };
    },
    components: {
        TicketList,
        AppBreadCrumb,
        OSRWaitingAnswer,
        ArchiveIcon,
        AwaitingTickets,
        TicketHistory,
        TicketForwarding,
        StatusTable,
        Modal2,
        InstagramIcon,
        MessengerIcon,
        SidebarChild,
    },
    computed: {
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        PERMISSION_TYPES() {
            return PERMISSION_TYPES;
        },
        ...mapState({
            isAdmin: (state) => state.auth.adminUser != null,
            topics: (state) => state.ticket.topics,
        }),
        currentFilterTemplate() {
            switch (this.selectedTab) {
                case "tickets":
                    return "this-week-open-tickets";
                case "instagram":
                    return "instagram";
                case "facebook":
                    return "messenger";
                case "form":
                    return "form";
                default:
                    return "this-week-open-tickets";
            }
        },
    },
    methods: {
        ...mapActions({
            fetchTopics: "ticket/fetchTopics",
        }),
        handleSidebarSelection(item) {
            this.selectedTab = item.key;
        },
        showModal() {
            this.isModalShow = true;
            this.ticketFormMode = true;
        },
        statusShowModal() {
            this.isModalShow = true;
            this.ticketFormMode = false;
        },
        hideModal() {
            this.isModalShow = false;
            this.reset();
        },
        reset() {
            this.ticketFormMode = true;
            this.statusForm = {
                title: "",
            };
        },
        handleSave() {
            if (this.statusForm.title === "") {
                this.isModalShow = true;
            } else {
                if (!!this.statusForm._id)
                    updateTicketStatus(this.statusForm).then(({ data }) => {
                        this.statuses = this.statuses.map((x) => {
                            if (x._id === data._id) return data;
                            return x;
                        });
                        this.reset();
                        this.ticketFormMode = false;
                        this.isModalShow = false;
                    });
                else
                    createTicketStatus(this.statusForm).then(({ data }) => {
                        this.statuses.push(data);
                        this.reset();
                        this.isModalShow = false;
                    });
            }
        },
        editStatus(id) {
            let maybeStatus = this.statuses.find((x) => x._id === id);
            if (!maybeStatus) return;
            this.statusForm = _.clone(maybeStatus);
            this.ticketFormMode = true;
        },
        deleted(id) {
            this.statuses = this.statuses.filter((x) => x._id !== id);
        },
    },
    mounted() {
        this.fetchTopics();
        readTicketStatus().then(({ data }) => {
            this.statuses = data;
        });
    },
    watch: {
        selectedTab(val) {
            this.$router.push({ query: { tab: val } });
        },
        "$route.query.platform"(val) {
            if (val === "instagram") {
                this.selectedTab = "instagram";
            } else if (val === "messenger") {
                this.selectedTab = "facebook";
            } else if (val === "form") {
                this.selectedTab = "form";
            }
        },
    },
};
</script>

<style>
.align-items-end {
    align-items: center !important;
}
</style>

<style lang="scss" scoped>
#ticket-component {
    display: flex;
    flex-direction: column;
    height: 100vh;

    .route-page-content {
        display: flex;
        flex: 1;
    }

    .position-relative {
        flex: 1;
        width: 100%;
        padding-top: 20px;
    }

    #time-select,
    #topic-select {
        border: none;
        background-color: #f3f6f9;
        padding: 3px 10px;
        border-radius: 6px;
        font-size: 12px;
        font-family: Poppins;
        font-weight: bolder;
        color: #3699ff;
        min-width: 130px;
    }

    .selected-link {
        color: #03a9f4;
        border: none;
        border-radius: initial;
        border-bottom: 2px solid #03a9f4;
        margin-right: 4px;
    }

    svgIcon {
        fill: #03a9f4;
    }

    svgIconTabChange {
        fill: #808184;
    }

    .menu-button {
        margin-right: 4px;
        border: none;
        display: flex;
        align-items: center;
        gap: 1px;
        justify-content: center;
    }

    .menu-button-base {
        background: transparent !important;
    }

    .custom-checkbox2 {
        background-color: #f3f6f9;
        border-radius: 6px;
        padding: 4px 6px;
        max-width: 120px;
        width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        font-family: Poppins;
        font-weight: 400;
        font-size: 12px;
        color: #1e1e2d;
    }

    .chatListSettingContainer {
        display: flex;
        justify-content: left;
        width: 40%;
        position: absolute;
        margin-top: 2px;
        z-index: 50;

        div {
            margin-right: 10px;
        }
    }

    #buttons {
        display: flex;
        justify-content: flex-end;
        gap: 7px;
    }
}
</style>
